"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Label = _styledComponents["default"].label.attrs(function () {
  return {
    className: "ml-1 form-check-label"
  };
}).withConfig({
  displayName: "Checkbox__Label",
  componentId: "sc-1aessgd-0"
})([""]);

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      checked = _ref.checked,
      onChange = _ref.onChange,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "checkbox" : _ref$id;
  return _react["default"].createElement("div", null, _react["default"].createElement("input", {
    type: "checkbox",
    id: id,
    checked: checked,
    onChange: onChange
  }), _react["default"].createElement(Label, {
    htmlFor: id
  }, label));
};

Checkbox.propTypes = {
  /** Label for the checkbox */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].node]).isRequired,

  /** If the checkbox is checked */
  checked: _propTypes["default"].bool.isRequired,

  /** on change callback from the checkbox */
  onChange: _propTypes["default"].func.isRequired,

  /** ID to pass to the checkbox */
  id: _propTypes["default"].string
};
Checkbox.defaultProps = {
  id: "checkbox"
};
var _default = Checkbox;
exports["default"] = _default;